<template>
<div class="animated fadeIn dashboard">

  <div class="col-md-8 pl-0">
    <div class="card col-md-12">
      <article class="card-body blog-card col-md-12">

        <div class="row">


          <h3 v-html="blogDetails.title"></h3>

          <p v-html="blogDetails.description"></p>

          <hr class="hrfull">

          <div class='clear10'>&nbsp;</div>

        </div>

        <div class="row">

          <div class="comment-row col-md-12 p-0">

            <!-- div class="col-md-1 col-sm-2 col-xs-2 col-lg-1 p-none">
                <img src="slike/face-circle.jpg" class="rounded-circle" width="40" height="40" alt="Myrtie Russel" title="Myrtie Russel" />
              </div -->

            <div class="col-md-9 col-sm-9 col-xs-9 col-lg-10 pl-0 input-com">
              <input type="text" class="form-control" id="comment" placeholder="Enter your comment" name="comment" v-model="formData.comment">
            </div>

            <div class="col-md-3 col-sm-3 col-xs-3 col-lg-2 btn-com">
              <button type="button" class="btn btn-primary btn-md btn-block" @click="submitComment(formData)">
                {{$t('SEND')}}
              </button>
            </div>

          </div>

        </div>

      </article>
    </div>
  </div>

  <div class="col-md-4 card smaller-comments">

    <article class="blog-card col-md-12">

      <h4>{{$t('COMMENTS')}}</h4>

      <div class="">
        <template v-for="item in blogDetails.comments">
          <div class="comment-single">
            <p><b v-html="item.comment"></b></p>
            <p>{{item.username}} | {{item.dateTime}}</p>
          </div>
        </template>
      </div>
    </article>

  </div>


</div>
</template>

<script>
import BlogApi from '@/api/cms/Blog'
import BlogCommentsApi from '@/api/cms/BlogComments'

export default
{
  name: 'DashboardDetails',
  data: function()
  {
    return {
      blogDetails:
      {},
      formData:
      {
        blogId: null,
        comment: ''
      }
    }
  },
  created()
  {
    var me = this;
    me.getBlogDetails();
  },
  methods:
  {
    async getBlogDetails()
    {
      var me = this;
      try
      {
        var data = await BlogApi.selectSingleRow(
        {
          'blogId': me.$route.params.blogId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.blogDetails = data.root;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async submitComment(item)
    {
      var me = this;
      try
      {
        me.$set(item, 'blogId', me.$route.params.blogId);
        var data = await BlogCommentsApi.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
        }
        else
        {
          me.$notify.notice(data);
          await me.getBlogDetails();
          me.formData.comment = '';
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    }
  },
  watch:
  {

  },
  computed:
  {

  }
}
</script>
